<template>
    <div class="wide-inner top-bar" :class="{'mobile-bar' : isMobile}">
        <img id="logo" :src="company.logo" :alt="company.name" class="src">
        <div class="menu">
            <!--div class="icon-holder top-notification">
                <img src="/images/icons/notif_ico.svg" alt="">
                <div class="notif-number-holder">
                    <p>{{num_notifications}}</p>
                </div>
            </div-->
            <template v-if="masqueraded">
                <span class="vert-divider"></span>
                <div class="icon-holder top-settings">
                    <a href="#" @click.prevent="unmask" title="Unmask" class="text-danger">
                        <i class="fa-regular fa-user-lock"></i>
                    </a>
                </div>
            </template>

            <template v-if="!isMobile && !assistant">
                <span class="vert-divider"></span>
                <div class="icon-holder top-settings">
                    <router-link :to="{name: 'settings'}">
                        <i class="fa-regular fa-gear"></i>
                    </router-link>
                </div>
                <span class="vert-divider"></span>
            </template>

            <div ref="profile" class="profile-holder" v-if="!isMobile" @click.prevent="openMenu">
                <p v-html="userName"></p>
                <p class="text-muted" v-if="assistant" v-html="'(' + $t('global.assisted_by') + ': ' + assistant.name + ')'"></p>
            </div>
        </div>
        <div ref="userMenu" class="user-menu">
            <div class="d-flex flex-column">
                <router-link :to="{name: 'settings'}" class="user-menu-item" v-if="!assistant">
                    <p><i class="fa-regular fa-gear"></i>{{ $t('global.settings') }}</p>
                </router-link>
                <router-link :to="{name: 'logout'}" class="user-menu-item">
                    <p><i class="fa-regular fa-right-from-bracket fa-fw"></i>{{ $t('auth.logout') }}</p>
                </router-link>
            </div>
        </div>
    </div>

</template>
<script>
import { mapState } from 'pinia'
import { useUser } from '../../stores/user';
import { createPopper } from '@popperjs/core';

export default {
    props: {
        isMobile: {
            required: true,
            type: Boolean
        },
    },

    data() {
        return {
            menuOpen: false,
        };
    },

    computed: {
        ...mapState(useUser, {
            userName: 'name',
            company: 'company',
            canChangePassword: 'canChangePassword',
            masqueraded: 'masqueraded',
            assistant: 'assistant'
        }),

        num_notifications() {
            return '2'; //TODO: This is a stand in for the future notification system
        }
    },

    methods: {
        openMenu() {
            let tooltip = this.$refs['userMenu'];

            if (this.menuOpen) {
                tooltip.removeAttribute('data-show');
                this.menuOpen = false;
                return;
            }
            this.menuOpen = true;

            let button = this.$refs['profile'];
            tooltip.setAttribute('data-show', '');

            createPopper(button, tooltip, {
                placement: 'top',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 10],
                        },
                    },
              ],
            });
        },

        unmask() {
            this.axios.post('/api/unmask').then(() => {
                window.location.replace(window.location.href);
            })
        }
    }
}
</script>
